<template>
<div>
  <loading v-if="isLoading"></loading>
  <header-navbar></header-navbar>
  <router-view></router-view>
  <common-footer></common-footer>
</div>
</template>

<script>
import Loading from '@/components/molecules/Loading'
import HeaderNavbar from '@/components/organisms/HeaderNavbar'
import CommonFooter from '@/components/organisms/CommonFooter'

export default {
  name: 'AppPosts',

  components: {
    Loading,
    HeaderNavbar,
    CommonFooter,
  },
}
</script>
